import { render, staticRenderFns } from "./moreissue.vue?vue&type=template&id=a22aa3b0&scoped=true&"
import script from "./moreissue.vue?vue&type=script&lang=js&"
export * from "./moreissue.vue?vue&type=script&lang=js&"
import style0 from "./moreissue.vue?vue&type=style&index=0&id=a22aa3b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22aa3b0",
  null
  
)

export default component.exports